import {
  convertDateHoursInMilliseconds,
  convertDateToTargetTimeZoneDate,
  isWeekendFromDate,
} from "@faire/help-center-utils/lib/dateInTimeZone";
import { getSettingPhoneWorkingHours } from "@faire/help-center-utils/settings/getSettingPhoneWorkingHours";

export const isPhoneInBusinessHours = () => {
  const { start_at, end_at, timezone } = getSettingPhoneWorkingHours();
  if (start_at === undefined || end_at === undefined) {
    return false;
  }
  const now = new Date();
  const targetDate = convertDateToTargetTimeZoneDate(
    now,
    timezone ?? "America/New_York"
  );
  if (isWeekendFromDate(targetDate)) {
    return false;
  }
  const hoursInMilliseconds = convertDateHoursInMilliseconds(targetDate);
  return start_at <= hoursInMilliseconds && hoursInMilliseconds < end_at;
};
